// @flow
export const STORAGE_KEY = 'form-spy-manager'

export const STORE_NAME = 'formSpyValues'
